import { render, staticRenderFns } from "./SelfscanningCompleted.vue?vue&type=template&id=b970da1c"
import script from "./SelfscanningCompleted.vue?vue&type=script&lang=js"
export * from "./SelfscanningCompleted.vue?vue&type=script&lang=js"
import style0 from "./SelfscanningCompleted.vue?vue&type=style&index=0&id=b970da1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports